module.exports = __webpack_public_path__ + "images/a4f77a7ef3c11ae756669aa590462255-bronze_badge.png";